<template>
  <v-container id="footer" class="pa-0" fluid>
    <v-container class="pa-0 content-wrapper">
      <div class="footer-info float-left">
        <p>東港鎮水資源回收中心</p>
        <div class="line"></div>
        <p>地址：928009 屏東縣東港鎮嘉蓮里1鄰鵬灣大道三段260號</p>
        <p>電話：08-8320367</p>
      </div>
      <div class="copyright-info">
        <p>COPYRIGHT ©2019 PINGTUNG DONGGANTEST ALL RIGHTS RESERVED.</p>
      </div>
    </v-container>
  </v-container>
</template>
<script>
export default {
  components: {},
  name: 'FooterPart',
  data () {
    return {
    }
  },
  watch: {
  },
  created () {
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
#footer{
  background-color: #505050;
  height:174px;
  color: #fff;
  position:relative;
  .footer-info{
    font-size: 15px;
    padding-top: 30px;
    p{
      margin-bottom: 5px;
    }
  }
  .content-wrapper{
    position: relative;
    height:174px;
  }
  .copyright-info{
    font-size: 12px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>
